//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script = {
  name: 'EumTagInputMobile',
  // vue component name
  props: {
    value: {
      type: Array,
      default: []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    useInput: {
      type: Boolean,
      default: true
    },
    mailValidMsg: {
      type: String,
      default: 'email format valid'
    },
    isShow: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    tags: {
      get() {
        if (!this.changeByInput) {
          this.idxInput = this.value.length;
        } else {
          this.changeByInput = false;
        }

        return this.initTags(this.value);
      },

      set(value) {
        this.$emit('input', value.filter(t => t.type !== 'input'));
      }

    }
  },

  data() {
    return {
      text: '',
      idxInput: -1,
      changeByInput: false,
      autoCompleteClearFlag: false,
      ignoreBlur: false,
      ignoreEnter: false,
      showAutoComplete: false
    };
  },

  mounted() {
    if (!window.eumTagInputMobile) {
      window.eumTagInputMobile = [];
      window.addEventListener('click', e => {
        let elem = e.target;

        if (elem) {
          if ((elem.className + '').indexOf('eum-tag-inputbox') == -1) {
            if (this.showAutoComplete) this.clearAllAutoComplete();
          } else {
            let uniqueKey = `pos_${elem.offsetTop}_${elem.offsetLeft}`;
            window.eumTagInputMobile.forEach(x => {
              let tElem = x.$refs.input;

              if (tElem.length) {
                tElem = tElem[0];
              }

              let tuniqueKey = `pos_${tElem.offsetTop}_${tElem.offsetLeft}`;

              if (tuniqueKey != uniqueKey) {
                x.clearAutoComplete(true);
              }
            });
          }
        }
      }, false);
    }

    window.eumTagInputMobile.push(this);
  },

  methods: {
    initTags(tags) {
      const idx = this.idxInput;
      const input = {
        type: 'input'
      };

      if (idx < 0) {
        return [...tags, input];
      } else {
        return [...tags.slice(0, idx), input, ...tags.slice(idx)];
      }
    },

    clearAllAutoComplete() {
      window.eumTagInputMobile.forEach(x => {
        x.clearAutoComplete(true);
      });
    },

    clearAutoComplete(flag) {
      if (this.autoCompleteClearFlag == false || flag) {
        this.$emit('changeAutoComplete');
      }
    },

    keyupEvent($event) {
      this.text = $event.target.value;
      this.$nextTick(() => {
        this.$emit('inputKeyDown', $event);
      });
    },

    blurEvent($event) {
      // this.$emit('receiverUpdate');
      // setTimeout(() => {
      //     this.clearAutoComplete();
      // }, 10);
      if (!this.ignoreBlur) {
        if (!this.ignoreEnter) this.enterEvent($event);
      }
    },

    enterEvent($event) {
      this.ignoreBlur = true;
      if (this.showAutoComplete) this.clearAutoComplete();
      let isEmail = false;

      if (this.text && this.text.length) {
        if (/^[a-z0-9][a-z0-9-_\.]+@([a-z]|[a-z0-9]?[a-z0-9-]+[a-z0-9])\.[a-z0-9]{2,10}(?:\.[a-z]{2,10})?$/.test((this.text || '').toLowerCase())) {
          isEmail = true;
        } else {
          alert(this.mailValidMsg);
          return;
        }
      }

      if (!this.ignoreEnter || isEmail) {
        this.appendByKey($event);
      }

      this.ignoreBlur = false;
    },

    appendByKey(moveFocus, obj) {
      if (moveFocus === undefined) {
        moveFocus = true;
      }

      if (this.text) {
        this.changeByInput = true;
        var idxInput = this.getInputIndex();
        var tag = obj || {
          text: this.text,
          value: this.text,
          comCode: this.comCode,
          deptCode: this.deptCode
        };
        this.tags = [...this.tags.slice(0, idxInput), tag, ...this.tags.slice(idxInput)];
        this.text = '';
        this.$emit('tagAdded', tag);

        if (moveFocus) {
          this.setInputFocus();
        }

        this.idxInput = idxInput + 1;
      }
    },

    deleteBykey($event) {
      if (!this.text) {
        // var idxInput = this.getInputIndex();
        var idxDel;
        var isLeft;
        const keycode = $event.keyCode;

        if (keycode ===
        /* backspace */
        8) {
          isLeft = true;
          idxDel = idxInput - 1;
          $event.preventDefault();
        } else if (keycode ===
        /* delete */
        46) {
          isLeft = false;
          idxDel = idxInput + 1;
        } else {
          return;
        }

        if (idxDel >= 0) {
          const tagDel = this.tags[idxDel];
          this.changeByInput = true;
          this.tags = [...this.tags.slice(0, idxDel), ...this.tags.slice(idxDel + 1)];
          this.$emit('tagDeleted', tagDel);
          this.setInputFocus();
          this.idxInput = isLeft ? idxInput - 1 : idxInput;
        }
      }
    },

    deleteTag($event, tag) {
      var index = this.tags.indexOf(tag);

      if (index >= 0) {
        //this.$emit('beforeDeleteTag', tag);
        this.changeByInput = true;
        this.tags = [...this.tags.slice(0, index), ...this.tags.slice(index + 1)];
        this.setInputFocus();
        this.$emit('tagDeleted', tag); //this.$emit('afterDeleteTag');
      }
    },

    moveInput($event) {
      var idxInput = this.getInputIndex();
      var idxMove;

      if ($event.keyCode ===
      /* left */
      37) {
        idxMove = idxInput - 1;
      }
      /* right:39 */
      else {
        idxMove = idxInput + 1;
      }

      if (idxMove >= 0 && idxMove < this.tags.length) {
        this.changeByInput = true;
        this.idxInput = idxMove;
        var tags = [...this.tags.slice(0, idxInput), ...this.tags.slice(idxInput + 1)];
        this.tags = [...tags.slice(0, idxMove), this.tags[idxInput], ...tags.slice(idxMove)];
        this.setInputFocus();
      }
    },

    getInputIndex() {
      return this.tags.findIndex(t => t.type === 'input');
    },

    setInputFocus() {
      this.$nextTick(() => this.$refs.input[0].focus());
    }

  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

/* script */
const __vue_script__ = script;
/* template */

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "eum-tag-input"
  }, [_c('ul', {
    staticClass: "tag-node-container"
  }, _vm._l(_vm.tags, function (tag, index) {
    return _c('li', {
      key: index,
      staticClass: "tag-node"
    }, [tag.type === 'input' && _vm.useInput ? _c('div', {
      staticClass: "input-wrapper"
    }, [!_vm.disabled ? _c('input', {
      ref: "input",
      refInFor: true,
      staticClass: "eum-tag-inputbox",
      domProps: {
        "value": _vm.text
      },
      on: {
        "keyup": _vm.keyupEvent,
        "keydown": [_vm.deleteBykey, function ($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
            return null;
          }

          return _vm.enterEvent.apply(null, arguments);
        }],
        "blur": _vm.blurEvent
      }
    }) : _vm._e()]) : _c('div', {
      staticClass: "tag-face"
    }, [_c('div', {
      staticClass: "tag-face-content"
    }, [_vm._t("default", null, {
      "tag": tag
    })], 2), _vm._v(" "), !_vm.disabled ? _c('div', {
      staticClass: "tag-face-actions",
      on: {
        "click": function ($event) {
          return _vm.deleteTag($event, tag);
        }
      }
    }, [_c('i', {
      staticClass: "icon-close"
    })]) : _vm._e()])]);
  }), 0)]);
};

var __vue_staticRenderFns__ = [];
/* style */

const __vue_inject_styles__ = undefined;
/* scoped */

const __vue_scope_id__ = undefined;
/* module identifier */

const __vue_module_identifier__ = undefined;
/* functional template */

const __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);

// Import vue component

const install = function installEumTagInputMobile(Vue) {
  if (install.installed) return;
  install.installed = true;
  Vue.component('EumTagInputMobile', __vue_component__);
}; // Create module definition for Vue.use()


const plugin = {
  install
}; // To auto-install when vue is found
// eslint-disable-next-line no-redeclare

/* global window, global */

let GlobalVue = null;

if (typeof window !== 'undefined') {
  GlobalVue = window.Vue;
} else if (typeof global !== 'undefined') {
  GlobalVue = global.Vue;
}

if (GlobalVue) {
  GlobalVue.use(plugin);
} // Inject install function into component - allows component
// to be registered via Vue.use() as well as Vue.component()


__vue_component__.install = install; // Export component by default
// also be used as directives, etc. - eg. import { RollupDemoDirective } from 'rollup-demo';
// export const RollupDemoDirective = component;

export default __vue_component__;
